import { graphql } from "gql";

const EDIT_TAG_SEEN_MUTATION = graphql(`
  mutation EditTagSeen($id: ID!, $isSeen: Boolean!) {
    editTag(id: $id, input: { isSeen: $isSeen }) {
      id
      isUnseen
    }
  }
`);

export default EDIT_TAG_SEEN_MUTATION;
